import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { LessonFilter, ILessonFilterInitData, SearchDto } from "./LessonFilter";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxFilterOverlay } from "../../Utility/AxFilterOverlay";
import Glide from "@glidejs/glide";
import { LessonLevel } from "../../Models/Lesson/LessonLevel";
import { RentalPersonType } from "../../Models/Rental/RentalPersonType";
import { LessonLocation } from "../../Models/Lesson/LessonLocation";
import { SelectionAddSlot } from "./SelectionAddSlot";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { LessonPackageStorage } from "./LessonPackageStorage";
import tippy from 'tippy.js';

@ModuleName("LessonPackage.Selection")
export class Selection implements AxInit {
    init: ILessonPackageSelectionInit;
    allIntersectionObserversRegistered: boolean = false;
    glide: Glide;
    trackedDates: string[] = [];
    packageStorage: LessonPackageStorage;


    dateSelectionLoading: boolean = false;
    dateSelectionBuffer: {
        $target: JQuery<HTMLElement>;
        source: HTMLElement;
        count: number;
        date: string;
    }[] = [];

    constructor(private _axLoading = new AxLoading(),
        private _lessonFilter = new LessonFilter(),
        private _filterOverlay = new AxFilterOverlay(),
        private _selectionAddSlot = new SelectionAddSlot(),
        private _i18nHelper = new I18nHelper()) { }

    AxInit(init: ILessonPackageSelectionInit): void {
        //LevelStuff
        this.init = init;
        this._selectionAddSlot.init(this._lessonFilter, init);

        this.initLibs();

        this.updateFilterLabel(init.currentSearch);

        $(`[data-display-lp-calendar-nav-dir]`).on('click',
            (e) => {
                const $targetButton = $(e.delegateTarget);
                const direction = $targetButton.attr('data-display-lp-calendar-nav-dir');

                this.shiftTrackedDates(direction);
            });

        $('.lessonPackage_selection_dateSlider > div:not(.inactive)').on('click',
            (e) => {
                let targetDate = $(e.delegateTarget).attr('data-date');
                this._lessonFilter.updateDate(targetDate);
            });

        $('[data-display-lp-reset="level"]').on('click', (e) => {
            $('[name=lessonPackage_filter_level-input]').prop('checked', false);
            $('[name=lessonPackage_filter_level-input]').trigger('change');
        });

        $('[data-display-lp-reset="location"]').on('click', (e) => {
            $('[name=lessonPackage_filter_location-input]').prop('checked', false);
            $('[name=lessonPackage_filter_location-input]').trigger('change');
        });
    }

    initLibs() {
        const init = this.init;
        this.initCurrentSearch(init);
        this.setStorageSearch();
        this._lessonFilter.init(init.filterData);
        this._lessonFilter.setDefaults(init.currentSearch);
        this.initDateSwiper();

        this._lessonFilter.getSearchSubject().subscribe((x) => {

            //@ts-ignore
            $(`[data-display-lp-calendar-nav="dropdown"`)[0]._tippy.hide();
            const searchDate = x.date;

            this.updateTrackedDates(searchDate);
            this.loadSelectionList(x);
            this._filterOverlay.toggleFilterBar(false);
        });

        this._lessonFilter.getSearchUpdateSubject().subscribe((x) => {
            this.packageStorage.cleanDefaultLevelStorage();
            this.updateFilterLabel(x);
        });

        this.initCalendarObserver();

        $(document).ajaxStart(() => {
            if (!this.dateSelectionLoading) return;

            this.setupSkeletons();
        });

        $(document).ajaxStop(() => {
            if (this.dateSelectionBuffer.length === 0) return;

            $('.calendar-body').removeClass('is-loading');

            for (let bufferE of this.dateSelectionBuffer) {
                const $target = $(`.lessonPackage_selection_dateList [data-date=${bufferE.date}]`);

                if ($target.length === 0) continue;

                bufferE.$target.html(bufferE.source);
                bufferE.$target.toggleClass('ax-bg-lg-gray-100', bufferE.count === 0);
                $target.toggleClass('ax-bg-lg-gray-100', bufferE.count === 0);

                this._selectionAddSlot.initListEvents(bufferE.$target[0]);
            }

            this._selectionAddSlot.markSelectedSlots();
            this.dateSelectionBuffer = [];
            for (let bodyE of $('.calendar-body')) {
                this._axLoading.HideLoadingIndicator(bodyE);
            }
            this.dateSelectionLoading = false;
        });

        //$(`[data-display-lp-calendar-nav="dropdown"]`).on('click',
        //    () => {
        //        const instance = tippy(document.querySelector('[data-display-lp-calendar-nav="month"]'));
        //        instance.show();
        //    });
        //@ts-ignore
        const instance = tippy($(`[data-display-lp-calendar-nav="dropdown"]`)[0], {
            //@ts-ignore
            content: $(`[data-display-lp-calendar-nav="month"]`)[0]._tippy.popper,
            allowHTML: true,
            placement: 'bottom',
            trigger: 'click',
            arrow: false,
            interactive: true,
            maxWidth: 'none',
            animation: false,
            onShow: (instance) => {
                let $parent = $(instance.reference as HTMLElement);
                let $popperInstance = $(instance.popper);
                instance.popper.style.width = instance.reference.getBoundingClientRect().width + 'px';
                //@ts-ignore
                this._lessonFilter.dateDropdown.axDropdownEvents.interaction.afterOpen($parent, $popperInstance);
            },
            appendTo: () => document.body,
        });
    }

    initCurrentSearch(init: ILessonPackageSelectionInit) {
        init.currentSearch.date = init.currentSearch.date ?? moment().format('YYYY-MM-DD');

        if (init.currentSearch.quantity == null && init.personTypes.length === 1) {
            init.currentSearch.quantity = [
                {
                    id: init.personTypes[0].personTypeNr,
                    quantity: 1
                }
            ];
        }
    }

    setStorageSearch() {
        this.packageStorage = AxLoad.GetModule<LessonPackageStorage>("LessonPackageStorage");
        const defaultLevel = this.packageStorage.getDefaultLevelStorage();

        if (defaultLevel != null && defaultLevel.length !== 0) {
            this.init.currentSearch.levels = defaultLevel;
        }
    }

    shiftTrackedDates(direction: string) {
        const currentTargetDate = moment(this.trackedDates[0], 'YYYY-MM-DD');
        currentTargetDate.add(this.trackedDates.length * (direction === '<' ? -1 : 1), 'days');

        const lastDate = currentTargetDate.clone().add(this.trackedDates.length, 'days');
        if (lastDate.isBefore(moment())) return;

        this._lessonFilter.updateDate(currentTargetDate.format('YYYY-MM-DD'));
    }

    updateTrackedDates(searchDate: string) {
        if (searchDate === $('.calendar-body').attr('data-date')) return;

        const currentMom = moment(searchDate, 'YYYY-MM-DD');
        const tmpMom = currentMom.clone();

        $(`[data-display-lp-calendar-nav="dates"]`)
            .html(`${tmpMom.format('MMM D')} - ${tmpMom.add(this.trackedDates.length, 'days').format('MMM D')}`);

        for (let i = 0; i < $('.calendar-body').length; i++) {
            const target = currentMom.format('YYYY-MM-DD');
            const $targetElem = $($('.calendar-body')[i]);
            const $targetHead = $($('.lessonPackage_selection_dateList [data-date]')[i]);

            $targetHead.find(`[data-display-lp-calendar="day"]`).html(currentMom.format('dddd'));
            $targetHead.find(`[data-display-lp-calendar="date"]`).html(currentMom.format('D'));

            $targetHead.attr('data-date', target);
            $targetElem.attr('data-date', target);

            if (this.trackedDates.length > i) {
                this.trackedDates[i] = target;
            }
            currentMom.add(1, 'days');
        }
    }

    updateFilterLabel(currentSearch: SearchDto) {
        let levelText = this._i18nHelper.GetTranslation(Translations.LevelsAll);
        let infoText: string[] = [];

        if (currentSearch.levels != null && currentSearch.levels.length > 0) {
            levelText = this.init.levels.filter(x => currentSearch.levels.indexOf(x.lessonLevelNr) !== -1).map(x => x.name).join(', ');
        }

        $('.lessonPackage_selection_filterLabel-level').html(levelText);

        if (currentSearch.date != null && currentSearch.date != '') {
            let text = moment(currentSearch.date).format(this.init.filterData.datePattern);
            infoText.push(text);
        }

        if (currentSearch.quantity != null && currentSearch.quantity.filter(x => x.quantity > 0).length > 0) {
            let pTypeArr: string[] = [];
            for (let pType of currentSearch.quantity.filter(x => x.quantity > 0)) {
                let name = this.init.personTypes.find(x => x.personTypeNr === pType.id).name;
                let text = `${pType.quantity} ${name}`;
                pTypeArr.push(text);
            }
            infoText.push(pTypeArr.join(', '));
        } else {
            infoText.push(`<span class="font-italic">${this._i18nHelper.GetTranslation(Translations.People)}</span>`);
        }

        if (currentSearch.locations != null && currentSearch.locations.length > 0) {
            let locationArray = this.init.locations.filter(x => currentSearch.locations.indexOf(x.locationId) !== -1)
                .map(x => x.locationName);

            infoText.push(locationArray.join(', '));
        } else {
            infoText.push(`<span class="font-italic">${this._i18nHelper.GetTranslation(Translations.Location)}</span>`);
        }

        $('.lessonPackage_selection_filterLabel-level').html(levelText);
        $('.lessonPackage_selection_filterLabel-info').html(infoText.join(' | '));
    }

    loadSelectionList(currentSearch: SearchDto) {
        if (this.trackedDates.length === 0) return;

        this.dateSelectionLoading = true;
        for (let date of this.trackedDates) {
            let clone = { ...currentSearch }
            clone.date = date;
            AxessViewer.loadPartialView('/LessonPackage/_SelectionList',
                clone,
                (resp) => {
                    const $target = $(`.calendar-body[data-date=${resp.firstValidDate}]`);
                    this.dateSelectionBuffer.push({
                        $target: $target,
                        count: resp.count,
                        source: resp.view,
                        date: resp.firstValidDate
                    });
                },
                {});
        }
        $(`.lessonPackage_selection_dateSlider > div`).removeClass('active');
        $(`.lessonPackage_selection_dateSlider > div[data-date="${this.trackedDates[0]}"]`).addClass('active');

        const startOfWeek = moment(this.trackedDates[0], 'YYYY-MM-DD').startOf('week');
        const activeIndex = $('.lessonPackage_selection_dateSlider > div')
            .index($(`.lessonPackage_selection_dateSlider > div[data-date="${startOfWeek.format('YYYY-MM-DD')}"]`));
        this.glide.go(`=${activeIndex}`);
    }

    setupSkeletons() {
        let count = 0;
        $('.calendar-body').addClass('is-loading');
        for (let bodyE of $('.calendar-body')) {
            const $bodyE = $(bodyE);
            $bodyE.toggleClass('ax-bg-lg-gray-100', false);
            $(`.lessonPackage_selection_dateList > div`).toggleClass('ax-bg-lg-gray-100', false);
            $bodyE.html($($('.skeleton > div')[count]).html());
            count++;
        }
    }

    initCalendarObserver() {
        let options = {
            root: document.querySelector(".ax-calendar-planer"),
            rootMargin: "0px",
            threshold: [0.5],
        };

        let callback: IntersectionObserverCallback = (entries, observer) => {
            const originalTrack = [...this.trackedDates];
            entries.forEach((entry) => {
                const trackedDate = $(entry.target).attr('data-date');

                if (!entry.isIntersecting) {
                    this.trackedDates = this.trackedDates.filter(x => x !== trackedDate);
                } else if (this.trackedDates.findIndex(x => trackedDate === x) === -1) {
                    this.trackedDates.push(trackedDate);
                }
            });

            if (this.trackedDates.length > originalTrack.length) {
                this.loadSelectionList(this._lessonFilter.currentSearch);
            }
        };

        let observer = new IntersectionObserver(callback, options);
        $('.calendar-body').each((i, e) => {
            observer.observe(e);
        });
    }

    initDateSwiper() {

        this.glide = new Glide('.glide', {
            type: 'slider',
            perView: 7,
            touchRatio: 0.8,
            rewind: false,
            gap: 0,
            focusAt: 0
        });
        this.glide.on('swipe.move', (move) => {
            console.log(move);
        });
        this.glide.on('run.before', (move) => {
            console.log(move);
            if (move.direction === '=') return;

            let orgDate = moment($(this.glide._c.Html.slides[this.glide.index]).attr('data-date'),
                'YYYY-MM-DD');
            let currentDate = orgDate.clone().add(move.steps * -1, 'd');

            let startOfWeek = currentDate.clone();
            startOfWeek.startOf('week');
            let thisWeekDiff = currentDate.diff(startOfWeek, 'days');
            if (thisWeekDiff === 0) return;

            if (thisWeekDiff > 3) {
                thisWeekDiff = (7 - thisWeekDiff) * -1;
                startOfWeek.add(1, 'weeks');
            }

            if (orgDate.isSame(startOfWeek)) {
                move.steps = this.glide.index;
                move.direction = '=';
            } else {
                move.steps = move.steps + thisWeekDiff;
            }
        });


        //This is a self check, if the swiper shows weird behavior (sometimes 1 or 2 days of SoW) activate this
        //glide.on('move.after', (move) => {
        //    let currentDate = moment($(glide._c.Html.slides[glide.index]).attr('data-date'),
        //        'YYYY-MM-DD');
        //    let startOfWeek = currentDate.clone();
        //    startOfWeek.startOf('week');
        //    let thisWeekDiff = currentDate.diff(startOfWeek, 'days');

        //    console.log(`Date: ${currentDate.format('YYYY-MM-DD')} - SoW: ${startOfWeek.format('YYYY-MM-DD')}`);
        //    console.log(`Diff to sow: ${thisWeekDiff}`);
        //    if (thisWeekDiff === 0) return;

        //    console.log(`Glide Go to current: ${glide.index} - Target: ${glide.index + thisWeekDiff * -1}`);
        //    setTimeout(() => {
        //        glide.go(`=${glide.index + thisWeekDiff * -1}`);
        //    },
        //        25);
        //});

        this.glide.mount();

        let options = {
            root: document.querySelector(".glide"),
            rootMargin: "0px",
            threshold: [0.3, 0.5, 0.7, 1],
        };

        let previousX = 0;
        let previousRatio = 0;

        let callback: IntersectionObserverCallback = (entries, observer) => {
            entries.forEach((entry) => {
                if (!this.allIntersectionObserversRegistered) return;

                const date = moment($(entry.target).attr('data-date'), 'YYYY-MM-DD');
                const firstOfMonth = date.clone().startOf('month');

                if (!date.isSame(firstOfMonth, 'date')) return;

                const currTrans = $('.lessonPackage_selection_dateSlider').css('-webkit-transform').split(/[()]/)[1];
                const currentX = parseInt(currTrans.split(',')[4]);

                const currentRatio = entry.intersectionRatio;

                let switchDirection = '';
                let firstOfMonthDow = parseInt(firstOfMonth.format("e"));

                if (currentX < previousX) {
                    if (currentRatio > previousRatio && firstOfMonthDow <= 3) {
                        //state = "Scrolling right enter";
                        switchDirection = '>';
                    } else if (currentRatio < previousRatio && firstOfMonthDow > 3) {
                        //state = "Scrolling right leave";
                        switchDirection = '>';
                    }
                } else if (currentX > previousX) {
                    if (currentRatio < previousRatio && firstOfMonthDow <= 3) {
                        //state = "Scrolling left leave";
                        switchDirection = '<';
                    } else if (currentRatio > previousRatio && firstOfMonthDow > 3) {
                        //state = "Scrolling left enter";
                        switchDirection = '<';
                    }
                }

                previousX = currentX;
                previousRatio = currentRatio;

                if (switchDirection === '') return;

                let nextMonth;
                if (switchDirection === '>') {
                    nextMonth = firstOfMonth.clone();
                } else if (switchDirection === '<') {
                    nextMonth = firstOfMonth.clone().add(-1, 'days');
                }

                if (nextMonth == null) return;

                const newMonthName = nextMonth.format('MMMM');
                $('.lessonPackage_selection_monthname').html(newMonthName);
            });
        };
        let observer = new IntersectionObserver(callback, options);

        $('.lessonPackage_selection_dateSlider > div').each((i, e) => {
            observer.observe(e);
        });
        setTimeout(() => {
            this.allIntersectionObserversRegistered = true;
        }, 300);
    }

    insertBeforeIndex(element: HTMLElement, index: number) {
        this.glide.track.insertBefore(element, this.glide.track.children[index]);
        this.glide.refresh();
    }

    insertEnd(element: HTMLElement) {
        this.glide.track.insertBefore(element, this.glide.track.children.ength);
        this.glide.refresh();
    }
}

interface IPersonType {
    maskName: string;
    name: string;
    personTypeNr: number;
    shortName: string;
}

export interface ILessonPackageSelectionInit {
    filterData: ILessonFilterInitData;
    currentSearch: SearchDto;
    levels: LessonLevel[];
    personTypes: IPersonType[];
    locations: LessonLocation[];
    submitUrl: string;
}